import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UserModel } from "models";
import { TOKEN_STORAGE_FIELD } from "constants/auth.constants";

interface UserData {
  user: UserModel | null;
}
interface TokenData {
  token: string | null;
}

type InitialState = UserData & TokenData;

const initialState: InitialState = {
  user: null,
  token: localStorage.getItem(TOKEN_STORAGE_FIELD) || null,
};

const auth = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetUserStore: (state) => {
      state.user = null;
      state.token = null;
    },
    setUser: (state, action: PayloadAction<UserModel>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
  },
});

export const { resetUserStore, setUser, setToken } = auth.actions;

export default auth.reducer;
